import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { addToFavorites, removeFromFavorites } from '../../actions/favoritesPageActions';
import {
    clearFilterParams,
    doNewSearchViaUrl,
    setFilterParam,
    setLoadingState,
    updateFacets,
    newFacetsSearch,
} from '../../actions/searchActions';
import { loadMoreUGCReviews, setReviewSorting } from '../../actions/ugcAction';
import { AdvisorTipps } from '../../components/AdvisorTipps';
import { CollapsibleDropDown } from '../../components/CollapsibleDropDown/CollapsibleDropDown';
import { CollapsibleDropDownTitle } from '../../components/CollapsibleDropDown/CollapsibleDropDownTitle';
import { CollapsibleText } from '../../components/CollapsibleDropDown/CollapsibleText';
import ReviewsDesktop from '../../components/DesktopReviews/DesktopReviews';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import { GallerySliderSection } from '../../components/GallerySection';
import { LikeIcon } from '../../components/Icons/LikeIcon';
import { StarIcon } from '../../components/Icons/StarIcon';
import { Section } from '../../components/NavigationPanel';
import { cruiseList } from '../../components/Recommendation/recommendation';
import RecommendationSection from '../../components/Recommendation/RecommendationSection';
import RecommendationZones from '../../components/RecommendationZones/RecommendationZones';
import { shipList } from '../../components/Recommendation/shipList';
import { SearchMask } from '../../components/SearchFilters/SearchMask';
import { SearchSection } from '../../components/SearchFilters/SearchSection';
import { ZoneAndCompanyInputSelection } from '../../components/SearchFilters/ZoneAndCompanyInputSelection';
import { TeaserSlider } from '../../components/TeaserSlider';
import * as Colors from '../../consts/variables';
import {
    getFilter,
    setFilter,
    setFilterArray,
    transformOptions,
} from '../../helpers/searchHelpers';
import { MarketContext } from '../../context/markets';
import { __ } from '../../helpers/TranslationService';
import { IUGCReviewsReducer } from '../../interfaces/IUGCReviews';
import { IState } from '../../reducers';
import { ICompanyDetailPageReducer } from '../../reducers/companyDetailPage';
import { IPageDataReducer } from '../../reducers/pageData';
import { IsomorphicHelpers } from '../../helpers/IsomorphicHelpers';
import { Feature } from '@paralleldrive/react-feature-toggles';
import { numberFormatter } from '../../helpers/TranslationService';

import { CompanyDesktopDetails } from './CompanyDesktopDetails';
import { CompanyMobileDetails } from './CompanyMobileDetails';

const styles: Record<string, React.CSSProperties> = {
    collapsibleMargin: {
        margin: '0px 15px',
    },
    sectionMargin: {
        margin: '0px 15px',
    },
    sectionBottomMargin: {
        marginBottom: 60,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'left',
        margin: '30px 15px 10px 0',
    },
    lastCollapsibleWrapper: {
        borderBottom: 0,
    },
    furtherInfoDropdown: {
        margin: 0,
        padding: 0,
    },
    iconProps: {
        flex: '0 0 auto',
    },
    childStyle: {
        margin: '0 -20px 0 0px',
        padding: 0,
    },
    advisorChildStyle: {
        margin: '10px 0',
    },
    CollapsibleChild: {
        padding: 0,
    },
};

interface StateProps {
    search: any;
    pageData: IPageDataReducer;
    companyDetailPage: ICompanyDetailPageReducer;
    favorites: number[];
    sortString: string;
    reviewsData: IUGCReviewsReducer;
    homePage: any;
}

interface DispatchProps {
    setFilterParam: typeof setFilterParam;
    doNewSearchViaUrl: typeof doNewSearchViaUrl;
    updateFacets: any; // @TODO this is breaking redux types
    addToFavorites: typeof addToFavorites;
    removeFromFavorites: typeof removeFromFavorites;
    clearFilterParams(fetchFacets: boolean);
    loadMoreUGCReviews: any; // @TODO this is breaking redux types
    setReviewSorting: typeof setReviewSorting;
    setLoadingState: (isLoading: boolean) => void;
    newFacetsSearch: any;
}

type IProps = StateProps & DispatchProps;

class CompanyDetailPageClass extends React.Component<IProps, any> {
    static contextType = MarketContext;
    constructor(props) {
        super(props);

        const deviceType = this.props?.pageData?.deviceType;

        const homePageLoaded = this.props.homePage.homePage === null;
        this.state = {
            showContent: !homePageLoaded,
            isDesktop: deviceType === 'desktop',
            firstLoad: true,
        };

        if (homePageLoaded) {
            this.props.setLoadingState(true);
            setTimeout(() => {
                this.props.setLoadingState(false);
                this.setState({ showContent: true });
            }, 1000);
        }
    }

    filterDefaults = {
        dateMax: null,
        dateMin: null,
        zone: 'default',
        company: this.props.companyDetailPage.companyId,
    };

    componentDidMount() {
        this.props.newFacetsSearch();
        this.resize();
        window.addEventListener('resize', this.resize);
        this.props.clearFilterParams(false);
        setFilterArray(
            ['company', 'zone'],
            this,
        )([this.props.companyDetailPage.companyId, 'default']);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize = () => {
        if (IsomorphicHelpers.isServerSide) return;

        const width = window.innerWidth;

        const isDesktop = width >= 1200;

        if (this.state.isDesktop !== isDesktop || this.state.firstLoad) {
            this.setState({ isDesktop, firstLoad: false });
        }
    };

    render() {
        const data = this.props.companyDetailPage;
        const { isCruise1st } = this.context.markets;
        const { zoneNids, companyNids, topCompanies, topZones } = this.props.search.searchFacets;
        const { dateMax, dateMin, zone, company } = getFilter(
            this.props.search,
            this.filterDefaults,
        );
        const { reviews, sortString, isLoading: areReviewsLoading } = this.props.reviewsData;
        const numResults = this.props.search.searchFacets.numResults;
        const disableButton = numResults ? false : true;
        const loadingButton = !numResults && numResults !== 0;
        const searchMaskProps = {
            pageType: 'Cruise Line Page',
            dateMax,
            dateMin,
            onDateMinChange: setFilter('dateMin', this),
            onDateMaxChange: setFilter('dateMax', this),
            sticky: false,
            isLoading: loadingButton,
            isDisabled: disableButton,
            doNewSearchViaUrl: this.props.doNewSearchViaUrl,
            showSearchBtn: true,
            onDateChange: setFilterArray(['dateMin', 'dateMax'], this),
            numberOfFiltersUsed: this.props.search.filterParamsList.length,
            languageCode: this.props.pageData.appConfig.languageCode,
            countryCode: this.props.pageData.appConfig.countryCode,
            headline: this.props.companyDetailPage.headline,
            title:
                (Number.isInteger(numResults) ? numberFormatter().format(numResults) + ' ' : '') +
                __('Search cruise', 'dreamlines'),
        };
        const zoneAndCompanyInputProps = {
            zoneNids,
            companyNids,
            topCompanies,
            topZones,
            zone,
            company,
            transformOptions: transformOptions,
            onCompanyChange: setFilter('company', this),
            onZoneChange: setFilter('zone', this),
            noPaddingTop: false,
            hideCompanyDropdown: isCruise1st,
        };
        const iconProps = {
            width: 20,
            height: 20,
            rectFill: Colors.transparent,
            style: styles.iconProps,
        };
        const starIconStyle: any = {
            fill: Colors.transparent,
            stroke: Colors.darkAcqa,
            strokeWidth: '30px',
        };
        const likeIconStyle: any = {
            fill: isCruise1st ? Colors.indigo : Colors.darkAcqa,
            flex: '0 0 auto',
        };

        const { name, phone, headline, text } = data.advisor;
        const advisorTitleString = headline;
        const isAdvisorDetailsPresent =
            name?.length || phone?.trim().length || text?.length || headline?.length;

        const advisorTitle = isAdvisorDetailsPresent ? (
            <CollapsibleDropDownTitle title={headline}>
                <LikeIcon width={20} height={20} style={likeIconStyle} />
            </CollapsibleDropDownTitle>
        ) : null;
        const reviewsTitleString = __(
            'Reviwes for %s',
            'dreamlines',
            this.props.companyDetailPage.title,
        );
        const reviewsTitle = (
            <CollapsibleDropDownTitle title={reviewsTitleString}>
                <StarIcon {...iconProps} style={starIconStyle} />
            </CollapsibleDropDownTitle>
        );
        const teaserTrackingData = { category: 'mobile-teaser-companypage', label: 'cruise' };
        const teaserData = this.props.companyDetailPage.images.map((val) => ({ imageUrl: val }));

        const furtherInfoTitleString = __(
            'Travel Tips for %s',
            'dreamlines',
            this.props.companyDetailPage.title,
        );

        const shipTitleString = `${this.props.companyDetailPage.title} - ${__(
            'All ships',
            'dreamlines',
        )}`;

        const recommendationProps = {
            pageData: this.props.pageData,
            cruiseRecommendations: this.props.companyDetailPage.cruises.slice(
                0,
                this.state.isDesktop ? 6 : undefined,
            ),
            trackingData: teaserTrackingData,
            isShipImage: this.state.isDesktop,
        };
        const shipListProps = {
            deviceType: this.props.pageData.deviceType,
            ships: data.ships,
            logo: this.props.companyDetailPage.logo,
        };

        const ugcFilterParams = this.props.companyDetailPage.ships
            .map((_) => `filterParams[company][]=${_.category}`)
            .join('&');

        const offerUrl = `/${this.props.pageData.brandConfig.slugsObj.searchresults}?filterParams[company][0]=${company}`;
        const galleryImages = this.props.companyDetailPage.images;
        const advisor = this.props.companyDetailPage.advisor;
        const advisorProps = {
            ...advisor,
            name: advisor.name || __('Call us', 'dreamlines'),
            phone: advisor.phone || this.props.pageData.brandConfig.phoneNumber,
        };

        const sections: Section[] = ['overview', 'offers', 'ships', 'reviews'];
        if (shipListProps.ships.length === 0) {
            sections.splice(2, 1);
        }
        if (isCruise1st) {
            sections.length = 0; // hide page navigation for cruise1st markets
        }

        let subHeadlineText = this.props.companyDetailPage.subHeadline;
        const showLearnMore = subHeadlineText.length > 230 && isCruise1st; //  If it’s more than 3 lines of text - then we have 2 lines + learn more link.
        if (showLearnMore) {
            subHeadlineText = `${subHeadlineText.slice(0, 150)}...`;
        }
        const onLearnMoreClicked = () => {
            const scrollToEl = document.getElementById('overview');
            if (scrollToEl) {
                scrollToEl.scrollIntoView({ behavior: 'smooth' });
            }
        };

        const hasReviews = reviews?.rating?.data?.length > 0;
        const hasShipsList = shipListProps.ships.length > 0;
        const dynamicFormClasses = classnames('dynamicForm', { transparent: isCruise1st });

        const desktopSections = {
            zoneRecommendation: () =>
                this.props.companyDetailPage?.zoneTabs?.length > 0 ? (
                    <RecommendationZones
                        title={__(
                            'Our Best %s Deals',
                            'dreamlines',
                            this.props.companyDetailPage.title,
                        )}
                        key="zoneRecommendation"
                        data={this.props.companyDetailPage?.zoneTabs}
                    />
                ) : (
                    desktopSections.recommendation()
                ),
            recommendation: () => (
                <RecommendationSection
                    key="recommendation"
                    data={cruiseList(recommendationProps)}
                    title={__(
                        'Cruise Offers for %s',
                        'dreamlines',
                        this.props.companyDetailPage.headline,
                    )}
                    favorites={this.props.favorites}
                    addToFavorites={this.props.addToFavorites}
                    removeFromFavorites={this.props.removeFromFavorites}
                    offerUrl={offerUrl}
                />
            ),
            gallery: () => (
                <GallerySliderSection
                    key="gallery"
                    offerUrl={offerUrl}
                    headline={this.props.companyDetailPage.headline}
                    content={this.props.companyDetailPage.description}
                    galleryImages={galleryImages}
                />
            ),
            form: () => (
                <DynamicForm
                    key="form"
                    className="dynamicForm row"
                    headline={this.props.companyDetailPage.title}
                />
            ),
            advisor: () =>
                advisor.headline &&
                advisor.text &&
                this.props.pageData.brandConfig.phoneNumber && (
                    <div className="row advisorSection" key="advisor">
                        <h2 className="headline">{advisorTitleString}</h2>
                        <AdvisorTipps {...advisorProps} />
                    </div>
                ),
            ships: () =>
                hasShipsList && (
                    <div className="row harboursSection" id="ships" key="ships">
                        <h2
                            className="headline"
                            dangerouslySetInnerHTML={{ __html: shipTitleString }}
                        />
                        <RecommendationSection
                            data={shipList(shipListProps)}
                            collapsibleComponent={true}
                        />
                    </div>
                ),
            seo: () => (
                <div className="row furtherInfoSection" key="seo">
                    <h2
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: furtherInfoTitleString }}
                    />
                    <div
                        className="furtherInfoSectionContent"
                        dangerouslySetInnerHTML={{
                            __html: this.props.companyDetailPage.seo.text,
                        }}
                    />
                </div>
            ),
            reviews: () => (
                <Feature
                    name="showReviews"
                    key="reviews"
                    activeComponent={() =>
                        hasReviews ? (
                            <div className="row ugcSection" id="reviews">
                                <h2
                                    className="headline"
                                    dangerouslySetInnerHTML={{
                                        __html: reviewsTitleString,
                                    }}
                                />
                                <div>
                                    <ReviewsDesktop
                                        reviews={reviews}
                                        offers={this.props.companyDetailPage.offers}
                                        priceCurrency={
                                            this.props.pageData.appConfig.defaultCurrency
                                        }
                                        loadMoreReviews={this.props.loadMoreUGCReviews}
                                        setSortString={this.props.setReviewSorting}
                                        sortString={sortString}
                                        filterParams={ugcFilterParams}
                                        reviewsType="companyReviews"
                                        shipTitle={'pageData.shipTitle'}
                                        googleScriptName={this.props.companyDetailPage.title}
                                        isLoading={areReviewsLoading}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                />
            ),
        };

        const mobileSections = {
            zoneRecommendation: desktopSections.zoneRecommendation,
            form: () => (
                <div style={styles.sectionBottomMargin} key="form">
                    <DynamicForm
                        className={dynamicFormClasses}
                        headline={this.props.companyDetailPage.title}
                    />
                </div>
            ),
            recommendation: () => (
                <div style={styles.sectionBottomMargin} key="recommendation">
                    <RecommendationSection
                        data={cruiseList(recommendationProps)}
                        title={__(
                            'Cruise Offers for %s',
                            'dreamlines',
                            this.props.companyDetailPage.headline,
                        )}
                        favorites={this.props.favorites}
                        addToFavorites={this.props.addToFavorites}
                        removeFromFavorites={this.props.removeFromFavorites}
                        offerUrl={offerUrl}
                    />
                </div>
            ),
            gallery: () => (
                <div style={styles.sectionBottomMargin} key="gallery">
                    <TeaserSlider teaserData={teaserData} />
                </div>
            ),
            description: () => (
                <div style={styles.sectionMargin} key="description">
                    <h2 style={styles.title}>{this.props.companyDetailPage.headline}</h2>
                    {data.description && <CollapsibleText text={data.description} />}
                </div>
            ),
            ships: () =>
                hasShipsList && (
                    <div style={styles.sectionBottomMargin} key="ships">
                        <div style={styles.sectionMargin}>
                            <h2 style={styles.title}>{shipTitleString}</h2>
                        </div>
                        <RecommendationSection
                            data={shipList(shipListProps)}
                            collapsibleComponent={true}
                        />
                    </div>
                ),
            advisor: () =>
                Boolean(isAdvisorDetailsPresent) && (
                    <div className="collapsibleSections" key="advisor">
                        <CollapsibleDropDown
                            title={advisorTitle}
                            childStyle={styles.advisorChildStyle}
                        >
                            <AdvisorTipps {...advisorProps} />
                        </CollapsibleDropDown>
                    </div>
                ),
            seo: () =>
                data?.seo?.text && (
                    <div
                        style={{ ...styles.sectionMargin, ...styles.sectionBottomMargin }}
                        key="seo"
                    >
                        <h2 style={styles.title}>{__('Further information', 'dreamlines')}</h2>
                        <CollapsibleText uncollapsedSpace={495} text={data.seo.text} />
                    </div>
                ),
            reviews: () => (
                <Feature
                    key="reviews"
                    name="showReviews"
                    activeComponent={() =>
                        hasReviews ? (
                            <CollapsibleDropDown
                                title={reviewsTitle}
                                childStyle={styles.CollapsibleChild}
                            >
                                <ReviewsDesktop
                                    reviews={reviews}
                                    offers={this.props.companyDetailPage.offers}
                                    priceCurrency={this.props.pageData.appConfig.defaultCurrency}
                                    loadMoreReviews={this.props.loadMoreUGCReviews}
                                    setSortString={this.props.setReviewSorting}
                                    sortString={sortString}
                                    filterParams={ugcFilterParams}
                                    reviewsType="companyReviews"
                                    shipTitle={'pageData.shipTitle'}
                                    googleScriptName={this.props.companyDetailPage.title}
                                    isLoading={areReviewsLoading}
                                />
                            </CollapsibleDropDown>
                        ) : null
                    }
                />
            ),
        };

        return (
            <div className="companyPage">
                <SearchSection
                    backgroundImage={this.props.companyDetailPage.headerImage}
                    headline={this.props.companyDetailPage.headline}
                    subHeadline={subHeadlineText}
                    learnMoreHandler={showLearnMore ? onLearnMoreClicked : undefined}
                >
                    <SearchMask {...searchMaskProps} pageData={this.props.pageData}>
                        <ZoneAndCompanyInputSelection {...zoneAndCompanyInputProps} />
                    </SearchMask>
                </SearchSection>

                <div
                    className="container"
                    style={this.state.isDesktop ? styles.sectionBottomMargin : null}
                >
                    {this.state.isDesktop && (
                        <CompanyDesktopDetails
                            breadcrumbs={this.props.companyDetailPage.breadcrumbs}
                            navigationItems={sections}
                            offerUrl={offerUrl}
                            sections={desktopSections}
                        />
                    )}
                    {!this.state.isDesktop && (
                        <CompanyMobileDetails
                            breadcrumbs={this.props.companyDetailPage.breadcrumbs}
                            sections={mobileSections}
                        />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IState): StateProps => ({
    search: state.search,
    pageData: state.pageData,
    companyDetailPage: state.companyDetailPage,
    favorites: state.favoritePage.favorites,
    sortString: (state.companyDetailPage as any).sortString,
    reviewsData: state.reviews,
    homePage: state.homePage,
});

const mapDispatchToProps: DispatchProps = {
    setFilterParam,
    doNewSearchViaUrl,
    updateFacets,
    addToFavorites,
    removeFromFavorites,
    clearFilterParams,
    loadMoreUGCReviews,
    setReviewSorting,
    setLoadingState,
    newFacetsSearch,
};

export const CompanyDetailPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CompanyDetailPageClass);
export default CompanyDetailPage;
